<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{
              id ? $i18n.t("Edit Offer - ") + offer.name : $i18n.t("Create Offer")
              }}
            </div>
          </template>

          <v-form id="form" ref="form" v-model="valid">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" style="margin-top:17px">
                  <v-text-field
                    :label="$i18n.t('Title') + '*'"
                    :rules="validationrules.name"
                    required
                    dense
                    v-model="offer.title"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" style="margin-top:17px">
                  <v-text-field :label="$i18n.t('Sub Title')" dense v-model="offer.subTitle" />
                </v-col>
                <v-col cols="5">
                  <z-date-picker
                    v-model="offer.validFrom"
                    :rules="validationrules.v_from"
                    :label="$i18n.t('Valid From') + '*'"
                    timestamp
                  />
                </v-col>
                <v-col cols="5">
                  <z-date-picker
                    v-model="offer.validTill"
                    :rules="validationrules.v_till"
                    :label="$i18n.t('Valid Till') + '*'"
                    timestamp
                  />
                </v-col>
                <v-col cols="5">
                  <z-date-picker
                    v-model="offer.travellingFrom"
                    :label="$i18n.t('User Travelling From  Date')"
                    timestamp
                  />
                </v-col>
                <v-col cols="5">
                  <z-date-picker
                    v-model="offer.travellingTill"
                    :label="$i18n.t('User Travelling Till Date')"
                    timestamp
                  />
                </v-col>
              </v-row>
              <v-card>
                <v-btn color="grey" small class="tariff-headers">
                  <h3>{{ $i18n.t("Offer") }}</h3>
                </v-btn>
                <v-row style="padding:10px 10px;">
                  <v-col cols="4">
                    <v-select
                      :items="offerType"
                      :label="$i18n.t('Offer Type')"
                      v-model="offer.offerType"
                      item-text="name"
                      item-value="value"
                    />
                  </v-col>
                  <v-col cols="4">
                    <z-currency-select
                      :label="$i18n.t('currency')"
                      class="purple-input"
                      v-model="offer.currency"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      :label="$i18n.t('Offer Amount') + '*'"
                      v-model="offer.amount"
                      :rules="validationrules.amount"
                      required
                    />
                  </v-col>
                  <v-col cols="2">
                    <toggle-button
                      v-model="offer.isAbs"
                      :labels="{ checked: '/-', unchecked: '%' }"
                      :height="25"
                      class="my-6"
                      :width="70"
                      :font-size="20"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :label="$i18n.t('Minmum Purchase Amount')"
                      dense
                      v-model="offer.minPurchase"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :label="$i18n.t('Maximum Off Amount')"
                      dense
                      v-model="offer.maxDiscount"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :label="$i18n.t('Coupon Code') + '*'"
                      dense
                      v-model="offer.couponCode"
                      :rules="validationrules.couponCode"
                      required
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :label="$i18n.t('Max no of Coupon Usage')"
                      v-model="offer.maxUses"
                    />
                  </v-col>
                  <v-col cols="4">
                    <z-vendor-select
                      class="purple-input"
                      v-model="offer.vendor_id"
                      :label="$i18n.t('Supplier')"
                    />
                  </v-col>
                  <v-col cols="4">
                    <z-client-select
                      class="purple-input"
                      v-model="offer.client_id"
                      :label="$i18n.t('Client')"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="tariffType"
                      :label="$i18n.t('Tariff Type')"
                      v-model="offer.tariffType"
                      item-text="name"
                      item-value="value"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox v-model="offer.active" :label="$i18n.t('Active')" />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox v-model="offer.isDefault" :label="$i18n.t('Is Default')" />
                  </v-col>
                </v-row>
              </v-card>
              <v-row>
                <v-col cols="12" md="12">
                  <vue-editor v-model="offer.desc" :rules="validationrules.desc" required></vue-editor>
                </v-col>
              </v-row>
            </v-container>

            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { VueEditor, Quill } from "vue2-editor";
@Component({
  components: {
    VueEditor,
    Quill,
  },
})
export default class Tickets extends Vue {
  valid = true;
  offer = {
    name: "",
    _id: null,
  };
  value = "";
  offerType = [
    {
      name: "Bank Offer",
      value: "BANK_OFFER",
    },
    {
      name: "Corp Offer",
      value: "CORP_OFFER",
    },
    {
      name: "Partner Offer",
      value: "PARTNER_OFFER",
    },
  ];
  tariffType = [
    {
      name: "DISPOSAL",
      value: "DISPOSAL",
    },
    {
      name: "TRANSFER",
      value: "TRANSFER",
    },
    {
      name: "FIXED ROUTE",
      value: "FIXED_ROUTE",
    },
    {
      name: "PACKAGE",
      value: "PACKAGE",
    },
    {
      name: "SIGHTSEEING",
      value: "SIGHTSEEING",
    },
    {
      name: "POINT TO POINT",
      value: "POINT_TO_POINT",
    },
    {
      name: "OUTSTATION",
      value: "OUTSTATION",
    },
  ];
  tariffTypeValue = "";
  validationrules = {
    v_from: [(v) => !!v || this.$i18n.t("Valid from is required")],
    v_till: [(v) => !!v || this.$i18n.t("Valid till is required")],
    desc: [(v) => !!v || this.$i18n.t("Description is required")],
    couponCode: [(v) => !!v || this.$i18n.t("Coupon Code is required")],
    amount: [(v) => !!v || this.$i18n.t("Amount is required")],
  };
  id = "";

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      let url_post;
      if (this.$route.params.id) {
        url_post = "/api/offer/" + this.$route.params.id + "/edit";
      } else {
        url_post = "/api/offer/new";
      }
      this.offer.amount = parseInt(this.offer.amount);
      common.setLoading(true);
      this.offer = await doPost(url_post, this.offer);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.offer = await doGet("/api/offer/" + id + "/detail");
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>

<style scoped>
.week-button {
  padding: 5px 4px;
  height: 30px;
  width: 30px;
  justify-content: center;
}
</style>
